// src/components/wellfinder/apiNumber.js
//
// The 8-to-10 digit API derivation, for DISPLAY ONLY.
//
// ── THIS IS NOT THE AUTHORITY. ───────────────────────────────────────────────
// admin-api/lib/wellfinder/apiNumber.js is, and it is the only code that writes
// an api10 to a record. This exists so the commit preview can show the analyst
// the ten-digit form they are about to store rather than the eight-digit form
// on the candidate card — confirming one thing and storing another is how a
// wrong identifier ends up in a deliverable.
//
// It returns null rather than guessing wherever the server would refuse. If the
// two ever disagree, THIS ONE IS WRONG: the preview would be describing a write
// the server will not perform, and a preview that lies is worse than no preview.
// The server's version throws on an unknown state code because it is writing a
// provenance-bearing value; this one shows a dash, because it is drawing text.
//
// The rule: RRC surface rows carry an EIGHT-character api in props->>'api' —
// measured across all 980,229 of them — and Texas is state code 42, so
// api10 = '42' + api8. Verified against the legacy corpus: 1,852 of 1,995
// correlated rows match exactly, and the 143 that differ resolve to a
// different RRC well rather than to a bad derivation.

const STATE_PREFIX_RRC = "42";

/**
 * @param {string|null|undefined} rrcApi the registry's own 8-char identifier
 * @returns {string|null} the 10-digit form, or null where the server would refuse
 */
export function api10FromRrcApi(rrcApi) {
  if (typeof rrcApi !== "string") return null;
  const t = rrcApi.trim();
  // Exactly eight digits. A shorter or longer string is not an api8 that has
  // lost a character — it is something else, and prefixing it would produce a
  // plausible-looking number for the wrong well.
  if (!/^\d{8}$/.test(t)) return null;
  return STATE_PREFIX_RRC + t;
}
